<template>
    <div class="product-card" :class="{ 'product-card--with-prices': shouldShowPrices }">
      <div class="product-card__icon-container">
        <AkIcon symbol="x" size="sm" class="product-card__remove-icon" data-testid="product-card-remove-product" @click="removeProduct" />
      </div>
      <img :src="imageCdnService.createUrl(imgSrc, '120')" :alt="name" class="product-card__img" data-testid="product-card-img">
      <AkParagraph class="product-card__name" data-testid="product-card-name">
          {{ name }}
      </AkParagraph>
      <div v-if="shouldShowPrices" class="product-card__price" data-testid="product-card-price">
        {{ formattedPrice }}
      </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { AkParagraph, AkIcon } from '@ankorstore/design-system';
import { Amount } from '@client/monolith/core/types/amount';
import usePrice from '@client/monolith/core/composables/use-price';
import { ImageCdnService } from '../../../types';

const { formatPrice } = usePrice();

defineOptions({
  name: 'ProductCard'
});

const props = defineProps<{
   name: string;
   imgSrc: string;
   price: Amount;
   shouldShowPrices?: boolean;
   imageCdnService: ImageCdnService;
}>();

const formattedPrice = computed(() => {
  return formatPrice(props.price);
});

const emit = defineEmits<{
  (e: 'removeProduct'): void
}>();

const removeProduct = () => {
  emit('removeProduct');
};

</script>


<style scoped lang="scss">
.product-card {
  @apply ds-bg-white ds-p-3 ds-rounded-md ds-w-[150px] ds-h-[230px];

  transition: height 0.1s ease-in-out;

  &--with-prices {
    @apply ds-h-[270px];
  }

  &__icon-container {
    @apply ds-flex ds-justify-end;
  }

  &__remove-icon {
    @apply ds-cursor-pointer ds-mb-2;
  }

  &__img {
    @apply ds-rounded-md ds-mb-3;
  }

  &__name {
    @apply ds-text-sm ds-line-clamp-2;
  }

  &__price {
    @apply ds-font-bold ds-mt-1 ds-text-sm;
  }
}
</style>